import { FormInstance } from 'antd';

export const MapResponseErrors = (error: any, form: FormInstance) => {
	if (error?.status === 422)
		Object.entries(error?.response?.data?.data?.errors).forEach(([key, value]) => {
			form.setFields([
				{
					name: key,
					errors: value as string[],
				},
			]);
		});
};
